<script lang="ts">
  import Icon from './Icon.svelte';
  let { message }: { message: string } = $props();
</script>

<div class="toast" role="status">
  <Icon name="check" size={16} />
  {message}
</div>

<style>
  .toast {
    position: fixed;
    left: 50%;
    bottom: 140px;
    transform: translateX(-50%);
    z-index: var(--z-toast);
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px var(--space-md);
    background: var(--color-navy);
    color: #fff;
    border-radius: var(--radius-pill);
    box-shadow: var(--shadow-panel);
    font-weight: 600;
    animation: toast-in var(--motion-base) var(--motion-easing);
  }
  @keyframes toast-in {
    from {
      opacity: 0;
      transform: translate(-50%, 8px);
    }
  }
</style>
